import {
	CommunityPerkDto,
	CommunityPerksFilter,
	CommunityProfileOnboardingDto,
	ListWithTotals,
	UserDto,
} from '@sweatpals/shared';
import { AxiosInstance, AxiosResponse } from 'axios';

export class CommunityProfilesService {
	constructor (private readonly httpClient: AxiosInstance) {}

	public async createCommunityProfile (
		data: CommunityProfileOnboardingDto,
		copyStripeIdFromAdmin?: boolean
	): Promise<AxiosResponse<UserDto>> {
		return this.httpClient.post<UserDto>('community-profiles', data, {
			params: {
				copyStripeIdFromAdmin,
			},
		});
	}

	public async getUserCommunityProfiles (userId: string): Promise<AxiosResponse<ListWithTotals<UserDto>>> {
		return this.httpClient.get(`/community-profiles`, {
			params: {
				userId,
			},
		});
	}

	public async getPublicCommunityPerks (
		communityId: string,
		filter?: CommunityPerksFilter
	): Promise<ListWithTotals<CommunityPerkDto>> {
		const { data } = await this.httpClient.get<ListWithTotals<CommunityPerkDto>>(`/community-perks/public/perks/${communityId}`, {
			params: filter,
		});

		return data;
	}

	public async getCommunityPerks (
		communityId: string,
		filter?: CommunityPerksFilter
	): Promise<ListWithTotals<CommunityPerkDto>> {
		const { data } = await this.httpClient.get<ListWithTotals<CommunityPerkDto>>(`/community-perks/perks/${communityId}`, {
			params: filter,
		});

		return data;
	}

	public async getCommunityPerksCount (communityId: string, filter?: CommunityPerksFilter): Promise<{ count: number }> {
		try {
			const { data } = await this.httpClient.get<{ count: number }>(`/community-perks/public/count-perks/${communityId}`, {
				params: filter,
			});

			return data;
		} catch (error) {
			console.error(error);

			return { count: 0 };
		}
	}

	public async getCommunityMemberShortPerks (
		communityId: string,
		filter?: CommunityPerksFilter
	): Promise<CommunityPerkDto[]> {
		const { data } = await this.httpClient.get(`/community-perks/public/member-perks-short/${communityId}`, {
			params: filter,
		});

		return data;
	}
}
